module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_5012.a8ba9b77.png";